import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Grid } from '@material-ui/core';

export const AwardImages = ({ awardImages }) => {
  return (
    <Grid
      container
      spacing={2}
      justifyContent='center'
      alignItems='center'
      style={{ paddingTop: '8rem' }}
    >
      {awardImages.map((image, index) => (
        <Grid item xs={12} md={6} key={index}>
          <GatsbyImage
            image={image?.asset.gatsbyImageData}
            alt={`Award Image ${index + 1}`}
            // imgStyle={{ objectFit: 'contain' }}
          />
        </Grid>
      ))}
    </Grid>
  );
};
